import { render } from "./AppNavi.vue?vue&type=template&id=3fba97e7&scoped=true"
import script from "./AppNavi.vue?vue&type=script&lang=js"
export * from "./AppNavi.vue?vue&type=script&lang=js"

import "./AppNavi.vue?vue&type=style&index=0&id=3fba97e7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fba97e7"
/* hot reload */
if (module.hot) {
  script.__hmrId = "3fba97e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fba97e7', script)) {
    api.reload('3fba97e7', script)
  }
  
  module.hot.accept("./AppNavi.vue?vue&type=template&id=3fba97e7&scoped=true", () => {
    api.rerender('3fba97e7', render)
  })

}

script.__file = "src/components/AppNavi.vue"

export default script